
<template xmlns="http://www.w3.org/1999/html">
  <div class="page-wrapper" id="page-wrapper" style="overflow-y: scroll; padding-bottom: 60px;">
    <div class="top-container">
      <div class="container" style="">
        <div class="row">
          <div class="col-6 col-sm-3 pt-0 pb-2">
            <button type="button" class="form-control text-left" @click="showDateSelector = true">
              <i class="fas fa-calendar-alt"></i> {{ deliveryDate }}
            </button>
          </div>
          <div class="col-6 col-sm-3  pt-0 pb-2">
            <select v-model="selectedDriverId" class="form-control">
              <option value="0">All Drivers</option>
              <option v-for="d in drivers" :key="'driver-selector-' + d.id" :value="d.id">{{d.name}}</option>
            </select>
          </div>
          <div class="col-6 col-sm-3  pt-0 pb-2">
            <button class="btn btn-success form-control" style="font-weight: bold; font-size: 1.3rem;" @click="getOrderList(true)">Orders</button>
          </div>
          <div class="col-6 col-sm-3  pt-0 pb-2">
            <button v-if="user !== null && (user.wmsPick === true || user.wmsPickCheck === true)" class="btn btn-primary form-control" style="font-weight: bold;font-size: 1.3rem;"  @click="getItemisedOrderList">Itemised</button>
          </div>
        </div>
      </div>
      <div style="width: 50%; height: 50px; padding: 5px;">

      </div>
      <div style="width: 50%; height: 50px; padding: 5px;">
<!--        <button class="btn btn-primary" @click="getOrderList">GET</button>-->

      </div>
    </div>

    <div class="body-container">
      <div class="container-fluid" v-if="orders.length > 0">
        <div class="row">
          <div class="col-12 col-sm-6 pt-0 pb-0" v-for="order in orders"  :key="'wms-order-' + order.id">
            <div class="wms-order-item" :class="'wms-order-state-' + order.state" @click="openOrder(order.id)">
              <div class="wms-order-item-title-container">
                <div class="wms-order-item-title" style="text-align: left; line-height: 25px; height: 70px;">
                  <b>{{order.merchantTitle}}</b>
<!--                  <div><i class="fas fa-map-marker"> </i> {{order.merchant.address}}</div>-->
<!--                  <div><i class="fas fa-phone"> </i> {{order.merchant.contact}}</div>-->
                </div>

              </div>
              <div style="width: 100%; display: flex;">
                <div class="wms-driver-info" style="width: 50%;">
                  <span v-if="order.driverId > 0"><i class="fas fa-truck"></i> <b>{{order.driverName}}</b></span>
                </div>
                <div class="wms-driver-info text-right" style="width: 50%; padding-right: 10px;">
                  <b>#{{order.id}}</b>
                </div>
              </div>

              <div class="wms-order-state">

                <div v-if="order.state >= 0 && order.state < 18" v-html="order.pickerInfo"></div>
                <span v-else>{{getOrderStateString(order)}}</span>

              </div>

<!--              <div class="wms-order-item-quantity">-->
<!--                {{item.orderedAmount}}-->
<!--              </div>-->
            </div>
<!--            <div v-for="item in items" class="wms-order-item" :key="'wms-order-item-' + item.id">-->
<!--              <div class="wms-order-item-title">-->
<!--                {{item.title}}-->
<!--              </div>-->
<!--              <div class="wms-order-item-quantity">-->
<!--                {{item.orderedAmount}}-->
<!--              </div>-->
<!--            </div>-->
          </div>
        </div>
      </div>

      <div class="container-fluid" v-if="orderCategories.length > 0">
        <div class="row">
          <div class="col-12 pt-0 pl-0 pr-0">
            <div v-for="cat in orderCategories" :key="'order-category-' + cat.id" class="wms-order-category-container" style="background: #ffe4e4; ">
              <div class="category-title" style="margin-bottom: 0; position: sticky; top: 0; z-index: 2;">{{cat.title}}</div>
              <div style="padding-left: 15px; padding-right: 15px; margin-bottom: 15px;">
                <template  v-for="p in cat.products">
                  <div v-if="p.orders !== null && p.orders.length >0" :key="'order-product-' + p.id" class="product-container" style="border-radius: 10px; overflow: hidden; box-shadow: 3px 3px 5px gray;">
                    <div class="product-title-new">{{p.title}}</div>
                    <div class="product-image-title" :class="'product-title-bg-' + p.productColourCode">
                      <div v-if="p.imageUrls !== null && p.imageUrls.length > 0"
                           style="width: 150px; height: 150px; background-size: cover; background-repeat: no-repeat"
                           v-bind:style="{backgroundImage: 'url(' + p.imageUrls[0]}"
                           @click="showProductInfoView(p)"
                      >

                      </div>
                      <div style="width: calc(100% - 150px);">
<!--                        <div class="product-image-code" style="width: 100%; height: 50px; line-height: 50px; font-size: 30px; text-align: center;" @click="showProductInfoView(p)">-->
<!--                          {{p.code}}-->
<!--                        </div>-->
                        <div style="width: 100%; padding: 0 10px;">
                          <div class="summary-container" v-html="getProductOrderStatusText(p)"/>
                        </div>
<!--                        <div style="width: 100%; height: 70px; line-height: 70px; display: flex; font-size: 20px; text-align: center; border-top: 1px solid #fff;">-->
<!--                          <div style="width: 50%; height: 70px;">{{p.orders.length}} order<span v-if="p.orders.length > 1">s</span></div>-->
<!--                          <div style="width: 50%; height: 70px; border-left: 1px solid #fff;">Qty: {{p.orderQuantity}}</div>-->
<!--                        </div>-->
                      </div>


                    </div>
                    <v-expansion-panels>
                    <v-expansion-panel :key="'product-order-expand-container-' + p.id">
                      <v-expansion-panel-header v-slot="{ expanded }">
                        <v-row no-gutters>
                          <v-col
                            class="text--secondary"
                            cols="12"
                          >Details
                          </v-col>
                        </v-row>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>

                        <div class="product-order-item-container collapse" style="padding: 10px;" :id="'product-container-' + p.id" >
                          <div v-for="item in p.orders" :key="'product-order-item-' + item.id">
                            <div class="wms-order-item" v-if="item.state >= 0" :class="{'full-confirmed': (p.useVariablePrice === false && item.midStockQuantity === item.amount) || p.useVariablePrice === true && item.midStockWeight > 0, 'partial-confirmed': item.midStockQuantity > 0 && item.midStockQuantity < item.amount, 'order-confirmed': item.state >= 18}">

                              <div class="wms-order-item-container">
                                <div class="wms-order-item-title">

                                  <b>{{item.merchant.title}}</b>
                                  <div v-if="item.orderDriverId > 0" style="padding-top: 10px;"><i class="fas fa-truck"></i> {{getDriverName(item.orderDriverId)}}</div>

                                </div>
                                <div class="wms-order-item-quantity-container">
                                  <div class="wms-order-item-quantity">
                                    {{item.amount}}

                                  </div>

                                </div>
                              </div>

                              <div style="text-align: right; padding-right: 10px;" v-if="item.state === 0">

                                  <div v-if="p.availableQuantity > 0 && p.availableQuantity < p.orderQuantity">
                                    Please open order and pick separately
                                  </div>
                                  <div v-else-if="p.availableQuantity <= 0" style="color:red; font-weight: bold;">No stocks</div>
                                  <button v-else-if="user.wmsPick === true && p.useVariablePrice === true" style="background: #ffc6c6; padding: 10px 20px; font-weight: bold;" @click="openWeightInputView(item, item.merchant)">Enter Weight</button>



                              </div>
                              <div class="wms-order-btn-container">
                                <div>
                                  <button v-if="item.state === 15 && user.wmsPickCheck === true" class="wms-white-button" @click="itemPickUncheck(item)">Cancel Check</button>
                                </div>
                                <template v-if="p.useVariablePrice === true">
                                  <div>

                                    <button v-if="item.state === 12 && user.wmsPickCheck === true" class="wms-white-button" @click="itemPickChecked(item)">Check {{item.midStockWeight}}kg</button>
                                    <span v-if="item.state > 12 && item.state < 18" style="font-size: 18px; font-weight: bold;">{{item.midStockWeight}}kg Checked</span>
                                  </div>
                                  <div v-if="item.state >= 12 && item.state < 18" style="font-size: 18px; font-weight: bold;">{{item.midStockWeight}}kg Picked</div>
                                  <div v-else-if="item.state >= 18"  style="font-size: 18px; font-weight: bold;">{{item.amount}} Confirmed</div>
                                </template>
                                <template v-else>
                                  <div>

                                    <button v-if="item.state === 12 && user.wmsPickCheck === true" class="wms-white-button" @click="itemPickChecked(item)">Check {{item.midStockQuantity}}</button>
                                    <span v-if="item.state > 12 && item.state < 18" style="font-size: 18px; font-weight: bold;">{{item.midStockQuantity}} Checked</span>
                                  </div>
                                  <div v-if="item.state >= 12 && item.state < 18" style="font-size: 18px; font-weight: bold;">{{item.midStockQuantity}} Picked</div>
                                  <div v-else-if="item.state >= 18"  style="font-size: 18px; font-weight: bold;">{{item.amount}} Confirmed</div>
                                </template>
                              </div>
                            </div>
                          </div>
                        </div>
                      </v-expansion-panel-content>

                    </v-expansion-panel>
                    </v-expansion-panels>
                    <div style="text-align: right; padding-right: 10px; padding-bottom: 15px; padding-top: 15px;">
                      <button v-if="user.wmsPick === true && p.useVariablePrice === false && p.showPickingButton === true" style="background: #ff8dff; color: white; font-weight: bold; border-radius: 10px; padding: 10px 20px; font-size: 20px;" @click="submitOrderItemsPick(p)">Pick <span style="">{{p.availableQuantity}}</span></button>
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <div style="text-align: center; font-size: 1.5rem; font-weight: bold;">
              --- END ---
            </div>
          </div>
        </div>

      </div>
    </div>
    <div style="position:fixed; top: 0; left: 0; width: 100%; height: calc(100% - 70px); background: rgba(0,0,0,0.4);" v-if="order !== false">
      <div style="position: absolute; width:calc(100% - 20px); height: calc(100% - 20px); margin: 10px; background: white;" @click.stop="dummy">
        <div style="width: 100%; height: 50px; padding-left: 10px; font-weight: bold; border-bottom: 1px solid #ccc;">
          {{order.merchantTitle}}
        </div>
        <div style="width: 100%; height: calc(100% - 100px); overflow-y: auto;">
          <div class="container pt-0">
            <div class="row pt-0" v-for="(item, ii) in order.list" :key="'order-item-view-' + item.id" style="background: #ffe4e4;"
              :class="{'margin-top-40': ii === 0 || item.categoryTitle !== order.list[ii-1].categoryTitle}">

              <div class="col-12 pt-0 pb-0 pl-0 pr-0" v-if="ii === 0 || item.categoryTitle !== order.list[ii-1].categoryTitle">
                <div class="category-title mb-0">
                {{item.categoryTitle}}
                </div>
              </div>
              <div class="col-12 col-sm-6 pt-0" v-if="item.state >= 0">
                <div class="wms-order-item" style="padding-top:0; box-shadow: 3px 3px 5px gray;" :class="{'full-confirmed': (item.product.useVariablePrice === false && item.midStockQuantity === item.amount) || (item.product.useVariablePrice === true && item.midStockWeight > 0), 'partial-confirmed': item.midStockQuantity > 0 && item.midStockQuantity < item.amount}">

                  <div class="wms-order-item-container" :class="'product-title-bg-' + item.product.productColourCode" style="border-top-right-radius: 10px;border-top-left-radius: 10px; overflow: hidden;">
<!--                    <div class="wms-order-item-title" style="text-align: left; padding: 0;">-->

                    <div class="wms-order-item-title" style="border-top-left-radius: 10px; overflow: hidden; padding: 0;"  @click="showProductInfoView(item.product)">
                      <div class="product-title-new" style="background: white;">{{item.title}}</div>
                      <div class="product-image-title">
                        <div v-if="item.product.imageUrls !== null && item.product.imageUrls.length > 0"
                             style="width: 150px; height: 150px; background-size: cover; background-repeat: no-repeat"
                             v-bind:style="{backgroundImage: 'url(' + item.product.imageUrls[0]}"
                        >

                        </div>
                        <div class="product-image-code text-left" style="width: calc(100% - 150px);">
                          <div class="text-center" style="height: 80px; line-height: 80px;">
                            {{item.product.code}}
                          </div>
                          <div style="width: 100%; height: 70px; line-height: 70px; text-align: center; font-size: 20px; border-top:1px solid white;">
                            Qty : {{item.amount}}
                          </div>
                        </div>
                      </div>
<!--                        <div class="product-image-container-quantity">{{p.orderQuantity}}</div>-->
                    </div>
<!--                      <b>{{item.title}} </b>-->
<!--                    </div>-->
<!--                    <div class="wms-order-item-quantity-container">-->
<!--                      ordered-->
<!--                      <div class="wms-order-item-quantity">-->
<!--                        {{item.amount}}-->
<!--                      </div>-->

<!--                    </div>-->
                  </div>
                  <div class="wms-order-btn-container" style="padding-top: 10px; padding-bottom: 10px;">
                    <div>
<!--                      {{item.id}} {{item.productId}}Available {{item.availablePickQuantity}}-->
                    </div>
                    <div></div>
                    <div v-if="item.product.useVariablePrice === true">
                      <label v-if="item.state === 0 && item.availablePickQuantity === 0" style="font-size: 20px; font-weight: bold; color: red;">No Stock!</label>
                      <label v-else-if="item.state === 0 && item.availablePickQuantity < item.amount" style="font-size: 20px; font-weight: bold; color: red;">Not enough stock!</label>
                      <button v-else-if="user.wmsPick === true && item.availablePickQuantity >= item.amount && item.state === 0" class="wms-btn" style="background: #ffc6c6; padding: 10px 20px; font-weight: bold;" @click="openWeightInputView(item, order.merchant)">Enter Weight</button>
                    </div>
                    <div v-else>
                      <label v-if="item.state === 0 && item.availablePickQuantity === 0" style="font-size: 20px; font-weight: bold; color: red;">No Stock! {{item.availablePickQuantity}}</label>
                      <label v-else-if="item.state === 0 && item.availablePickQuantity < item.amount" style="font-size: 20px; font-weight: bold; color: red;">No Stock!</label>
                      <button v-else-if="user.wmsPick === true && item.availablePickQuantity >= item.amount && item.state === 0" class="wms-btn" style="background: #99daff;" @click="submitOrderItemPick(item)">Pick {{item.availablePickQuantity}}</button>
                    </div>
                  </div>

                  <template v-if="item.state >= 0 && item.state < 20">
                    <div class="wms-order-item-inventory-list" style="display: none;">
                      <div class="wms-inventory-item" v-for="inv in item.inventories" :key="'inventory-item-' + inv.id" @click="showPickView(item, inv)">
                        <div>#{{inv.id}}</div>
                        <div>{{inv.area}}-{{inv.location}}-{{inv.section}}</div>
                        <div class="wms-stock-balance text-center">{{inv.availableQuantity}} </div>
                        <div class="wms-stock-balance wms-stock-picked text-center" v-if="inv.midStockQuantity > 0"> {{inv.midStockQuantity}}</div>
                      </div>
                    </div>
                    <div class="wms-order-btn-container" v-if="item.pickerConfirmedAmount === 0" style="display: none;">
                      <div>
                        <button class="wms-btn" style="background: #ffcccc;">Reject</button>
                      </div>
                      <div>
                        <button class="wms-btn" style="background: #d4ffcc;" @click="showPartialConfirmView(item)">Partial</button>
                      </div>
                      <div>
                        <button class="wms-btn" style="background: #99daff;" @click="itemFullConfirm(item)">{{item.amount}}</button>
                      </div>
                    </div>
                    <template v-if="item.product.useVariablePrice === true">
                      <div class="wms-order-btn-container" style="display: block;" v-if="item.midStockWeight > 0">
                        <div style="width: 100%;">
                          <button class="wms-btn" v-if="user.wmsPick === true && item.state === 12" style="background: white; color: red; font-weight: bold;" @click="itemConfirmCancel(item)">Revert</button>
                          <button class="wms-btn" v-if="user.wmsPickCheck === true && item.state === 15" style="background: white; color: #ff9d9d; font-weight: bold;" @click="itemPickUncheck(item)">Cancel Check</button>


                        </div>
                        <div style="width: 100%; padding-right: 10px; text-align: right;">
                          <div v-if="item.state >= 0 && item.state < 15">
                            <div>Total Picked <span style="font-size: 40px; padding-left: 10px; font-weight: bold;">{{item.midStockWeight}} kg</span></div>




                            <button v-if="user.wmsPickCheck === true " class="wms-btn" style="background: white; color: red; font-weight: bold;" @click="itemPickChecked(item)">Check {{item.midStockWeight}}</button>
                            <div v-if="user.wmsPickConfirm === true && user.wmsPickCheck === false" style="background: white; color: red; padding: 10px; font-weight: bold; font-size: 20px;">
                              Not checked yet
                            </div>
                          </div>

                          <div v-if="item.state === 15" style="font-size: 20px; font-weight: bold;">
                            Checked <span style="font-size: 40px; padding-left: 10px; font-weight: bold;">{{item.midStockWeight}} kg</span>
                          </div>

                          <!--                        <div v-else-if="item.state === 20" style="font-size: 20px; font-weight: bold;">-->
                          <!--                          <span style="font-size: 40px; padding-left: 10px; font-weight: bold;">{{item.midStockQuantity}}</span>-->
                          <!--                        </div>-->
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div class="wms-order-btn-container" v-if="item.midStockQuantity > 0">
                        <div>
                          <button class="wms-btn" v-if="user.wmsPick === true && item.state === 12" style="background: white; color: red; font-weight: bold;" @click="itemConfirmCancel(item)">Revert</button>
                          <button class="wms-btn" v-if="user.wmsPickCheck === true && item.state === 15" style="background: white; color: #ff9d9d; font-weight: bold;" @click="itemPickUncheck(item)">Cancel Check</button>


                        </div>
                        <div style="width: 66.66%; padding-right: 10px; padding-bottom: 10px; text-align: right;">
                          <div v-if="item.state >= 0 && item.state < 15">
                            <div>Total Picked <span style="font-size: 40px; padding-left: 10px; font-weight: bold;">{{item.midStockQuantity}}</span></div>




                            <button v-if="user.wmsPickCheck === true " class="wms-btn" style="background: white; color: red; font-weight: bold;" @click="itemPickChecked(item)">Check {{item.midStockQuantity}}</button>
                            <div v-if="user.wmsPickConfirm === true && user.wmsPickCheck === false" style="background: white; color: red; padding: 10px; font-weight: bold; font-size: 20px;">
                              Not checked yet
                            </div>
                          </div>

                          <div v-if="item.state === 15" style="font-size: 20px; font-weight: bold;">
                             Checked <span style="font-size: 40px; padding-left: 10px; font-weight: bold;">{{item.midStockQuantity}}</span>
                          </div>

  <!--                        <div v-else-if="item.state === 20" style="font-size: 20px; font-weight: bold;">-->
  <!--                          <span style="font-size: 40px; padding-left: 10px; font-weight: bold;">{{item.midStockQuantity}}</span>-->
  <!--                        </div>-->
                        </div>
                      </div>
                    </template>

                  </template>
<!--                  <div v-if="user.wmsPickConfirm === true && item.state < 18"  style="text-align: center;">-->
<!--                    <button v-if="item.product.useVariablePrice === true" class="wms-btn" style="background: white; color: red; font-weight: bold; margin: auto;" @click="openWeightFixView(item, order.merchant)">Fix picking weight</button>-->
<!--                    <button v-else class="wms-btn" style="background: white; color: red; font-weight: bold; margin: auto;" @click="openPickingFixView(item)">Fix picking quantity</button>-->
<!--                  </div>-->
                  <template v-if="item.state > 15">
                    <div class="text-right">
                      Confirmed
                      <span v-if="item.product.useVariablePrice === true" style="font-size: 40px; margin-right: 20px; font-weight: bold;">{{item.variablePriceAmountFloat}}kg</span>
                      <span v-else style="font-size: 40px; margin-right: 20px; font-weight: bold;">{{item.amount}}</span>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="width: 100%; height: 50px; display: flex;">
          <div style="width: 50%;">
            <button class="btn btn-dark" style="width: 100px; margin-left: 10px;" @click="closeOrder">CLOSE</button>
          </div>
          <div style="width: 50%; text-align: right;">
            <button class="btn btn-primary" style="width: 100px; margin-right: 10px;" v-if="user.wmsPickConfirm === true" @click="confirmOrder">CONFIRM</button>
          </div>
        </div>
      </div>
    </div>
    <div style="position:fixed; top: 0; left: 0; width: 100%; height: calc(100% - 70px); background: rgba(0,0,0,0.4);" v-if="partialConfirmView !== false">
      <div style="position: absolute; width:calc(100% - 20px); height: calc(100% - 20px); margin: 10px; background: white;" @click.stop="dummy">
        <div style="width: 100%; height: calc(100% - 70px); overflow-y: auto;">
          <div class="container">
            <div class="row">
              <div class="col-12">
                <b>{{partialConfirmView.item.title}}</b>
                <br/>
                {{partialConfirmView.orderedAmount}} requested
              </div>
            </div>
            <div class="row">
              <div class="col-4" v-for="q in partialConfirmView.orderedAmount">
                <div class="quantity-btn" :class="{'selected': q === partialConfirmView.amountToConfirm}" @click="partialConfirmView.amountToConfirm = q">{{q}}</div>
              </div>
            </div>
          </div>
        </div>
        <div style="width: 100%; height: 80px; text-align: center;">
          <div class="container pt-0 pb-0">
            <div class="row">
              <div class="col-6">
                <button class="btn wms-btn" @click="closePartialConfirmView">CLOSE</button>
              </div>
              <div class="col-6">
                <button class="btn wms-btn btn-primary" v-if="partialConfirmView.amountToConfirm > 0" @click="itemPartialConfirm">Confirm {{partialConfirmView.amountToConfirm}}</button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div style="position:fixed; top: 0; left: 0; width: 100%; height: calc(100% - 70px); background: rgba(0,0,0,0.4);" v-if="pickView !== false">
      <div style="position: absolute; width:calc(100% - 20px); height: calc(100% - 20px); margin: 10px; background: white;" @click.stop="dummy">
        <div style="width: 100%; height: calc(100% - 70px); overflow-y: auto;">
          <div class="container">
            <div class="row">
              <div class="col-12">
                <b>{{pickView.item.title}}</b>
                <br/>
                {{pickView.item.orderedAmount}} requested
              </div>
              <div class="col-12">
                <b>#{{pickView.inventory.id}}</b>
                <br/> {{pickView.inventory.availableQuantity}} available
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <div class="quantity-btn" :class="{'selected': pickView.form.quantity === pickView.maxQuantity}" @click="pickView.form.quantity = pickView.maxQuantity">Full {{pickView.maxQuantity}}</div>
              </div>
              <div class="col-4" v-for="q in pickView.maxQuantity">
                <div v-if="q < pickView.maxQuantity" class="quantity-btn" :class="{'selected': q === pickView.form.quantity}" @click="pickView.form.quantity = q">{{q}}</div>
              </div>
            </div>
          </div>
        </div>
        <div style="width: 100%; height: 80px; text-align: center;">
          <div class="container pt-0 pb-0">
            <div class="row">
              <div class="col-6">
                <button class="btn wms-btn" @click="closePickView">CLOSE</button>
              </div>
              <div class="col-6">
                <button class="btn wms-btn btn-primary" v-if="pickView.form.quantity > 0" @click="submitPick">Confirm {{pickView.form.quantity}}</button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div style="position:fixed; top: 0; left: 0; width: 100%; height: calc(100% - 70px); background: rgba(0,0,0,0.4);" v-if="pickingFixView !== false">
      <div style="position: absolute; width:calc(100% - 20px); height: calc(100% - 20px); margin: 10px; background: white;" @click.stop="dummy">
        <div style="width: 100%; height: calc(100% - 70px); overflow-y: auto;">
          <div class="container">
            <div class="row">
              <div class="col-12">
                <b>{{pickingFixView.item.title}}</b>
                <br/>
                {{pickingFixView.item.orderedAmount}} requested
              </div>
              <div class="col-12" v-if="pickingFixView.item.midStockQuantity > 0">
                Currently {{pickingFixView.item.midStockQuantity}} picked
              </div>
              <div class="col-12">
                {{pickingFixView.item.availablePickQuantity}} available
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <div class="quantity-btn" :class="{'selected': pickingFixView.form.quantity === pickingFixView.maxQuantity}" @click="pickingFixView.form.quantity = pickingFixView.maxQuantity">Full {{pickingFixView.maxQuantity}}</div>
              </div>
              <div class="col-4" v-for="q in pickingFixView.maxQuantity">
                <div v-if="q < pickingFixView.maxQuantity" class="quantity-btn" :class="{'selected': q === pickingFixView.form.quantity}" @click="pickingFixView.form.quantity = q">{{q}}</div>
              </div>
            </div>
          </div>
        </div>
        <div style="width: 100%; height: 80px; text-align: center;">
          <div class="container pt-0 pb-0">
            <div class="row">
              <div class="col-6">
                <button class="btn wms-btn" @click="closePickingFixView">CLOSE</button>
              </div>
              <div class="col-6">
                <button class="btn wms-btn btn-primary" v-if="pickingFixView.form.quantity > 0" @click="submitPickingFix">Confirm {{pickingFixView.form.quantity}}</button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div style="position:fixed; top: 0; left: 0; width: 100%; height: calc(100% - 70px); background: rgba(0,0,0,0.4); z-index: 100;" v-if="weightStockView !== false">
      <div style="position: absolute; width:calc(100% - 20px); height: calc(100% - 20px); margin: 10px; background: white;" @click.stop="dummy">
        <div style="width: 100%; height: calc(100% - 70px); overflow-y: auto;">
          <div style="width: 100%; padding: 10px; font-size: 20px;">
            {{weightStockView.order.title}}
          </div>
          <div style="width: 100%;padding: 10px; font-size: 20px; text-align: right;">
            {{weightStockView.merchant.title}}
          </div>
          <div style="width: 100%; line-height: 40px; text-align: center; font-size: 30px; padding-bottom: 10px; background: #ffe3c7;">
            Quantity : {{weightStockView.order.amount}} Fillets
<!--            <select v-model="weightStockView.quantity" style="padding: 10px 20px; border: 1px solid #ccc; border-radius: 10px; background: #eee;">-->
<!--              <option v-for="q in weightStockView.order.amount" :value="q">{{q}} fillets</option>-->
<!--            </select>-->
          </div>
          <div style="width: 100%; height: 70px;" class="number-input">
            {{weightStockView.weightInput}} <span style="font-size: 30px;">kg</span>
          </div>
          <div class="container">
            <div class="row">
              <div class="col-12">
                <table class="number-button-container">
                  <tr>
                    <td><div class="number-button" @click="weightNumberEntered(1)">1</div></td>
                    <td><div class="number-button" @click="weightNumberEntered(2)">2</div></td>
                    <td><div class="number-button" @click="weightNumberEntered(3)">3</div></td>
                  </tr>
                  <tr>
                    <td><div class="number-button" @click="weightNumberEntered(4)">4</div></td>
                    <td><div class="number-button" @click="weightNumberEntered(5)">5</div></td>
                    <td><div class="number-button" @click="weightNumberEntered(6)">6</div></td>
                  </tr>
                  <tr>
                    <td><div class="number-button" @click="weightNumberEntered(7)">7</div></td>
                    <td><div class="number-button" @click="weightNumberEntered(8)">8</div></td>
                    <td><div class="number-button" @click="weightNumberEntered(9)">9</div></td>
                  </tr>
                  <tr>
                    <td><div class="number-button darker" style="font-size: 30px;" @click="clearWeightInput">CLR</div></td>
                    <td><div class="number-button" @click="weightNumberEntered(0)">0</div></td>
                    <td><div class="number-button darker" @click="weightNumberBack" style="font-size: 30px;">DEL</div></td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div style="width: 100%; height: 70px;">
          <div class="container pt-0 pb-0">
            <div class="row">
              <div class="col-6">
                <button class="btn wms-btn" @click="closeWeightInputView">CLOSE</button>
              </div>
              <div class="col-6">
                <button class="btn wms-btn btn-primary" @click="submitWeightInput">SUBMIT</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="productInfo !== false" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.6);" @click.stop="productInfo = false;">
      <div style="position: absolute; top:50%; left: 50%; transform: translate(-50%, -50%); width: 400px; max-width: 90%; background: white;">
        <div style="width: 100%; line-height: 25px; padding-top: 20px; font-size: 18px; font-weight: bold; padding-left: 10px; padding-right: 10px; text-align: center;">
          {{productInfo.title}}
        </div>
        <div style="width: 100%; line-height: 25px; padding-top: 20px; padding-bottom: 20px; margin-top: 20px; font-size: 22px; font-weight: bold; text-align: center; background: #dadada;">
          {{productInfo.code}}
        </div>
        <div style="width: 100%;">
          <img v-if="productInfo.image !== null" style="width: 100%;" :src="productInfo.image"/>
        </div>
      </div>
    </div>
    <v-dialog v-model="showDateSelector" max-width="320">
      <v-date-picker
        v-model="deliveryDate"
        scrollable
        @change="onDeliveryDateSelected"
      />
    </v-dialog>
  </div>
</template>
<script>
import {
  getWmsCategories,
  getWmsConfirmOrder,
  getWmsDeliveryOrderItems, getWmsDriverList, getWmsItemisedOrders,
  getWmsOrder,
  getWmsOrders,
  getWmsPickerCancel,
  getWmsPickerConfirm,
  wmsMidStockCreate,
  wmsOrderItemMidStockChecked,
  wmsOrderItemMidStockCreate,
  wmsOrderItemMidStockUnchecked, wmsOrderItemPickingCorrection, wmsProductOrderItemsMidStockCreate
} from "../api/wms";
import {getOrderStateString, millisToDate, millisToHHMM, showDialog} from "../api/utils";
import {getUserByToken} from "../api/user";
const Stomp = require('stompjs');
export default {
  name: 'OrderStocks',
  data() {
    return {
      user:null,
      drivers:[],
      selectedDriverId:0,
      categories:[],
      selectedCategoryId:0,
      deliveryDate:'',
      showDateSelector: false,
      items:[],
      orders:[],
      orderCategories:[],
      order:false,
      partialConfirmView: false,
      pickView: false,
      connection:null,
      stompClient:null,
      pickingFixView: false,
      weightStockView: false,
      productInfo: false,
    }
  },
  created() {
    this.$data.deliveryDate = millisToDate(new Date().getTime(), '-');
    console.log("order stocks");
  },
  mounted() {
    this.getMyInfo();
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    dummy: function() {},
    timeString: millisToHHMM,
    getOrderStateString: getOrderStateString,
    getMyInfo: function() {
      let self = this;
      getUserByToken()
        .then(function(data) {
          self.$data.user = data;
          self.getCategories();

        })
        .catch(function(err) {

          console.log(err);

        })
    },
    getDriverName: function(id) {
      if(id === 0) {
        return 'No driver';
      }
      for(let i = 0 ; i < this.$data.drivers.length ; i++) {
        if(this.$data.drivers[i].id === id) {
          return this.$data.drivers[i].name;
        }
      }

      return 'Unknown(' + id + ')';
    },
    getProductOrderStatusText: function(product) {
      let quantity = 0;
      let picked = 0;
      let checked = 0;
      let confirmed = 0;

      for(let i = 0 ; i < product.orders.length ; i++) {
        quantity += product.orders[i].amount;
        if(product.orders[i].state >= 12) {
          picked += product.orders[i].amount;
          if(product.orders[i].state > 12) {
            checked += product.orders[i].amount;
            if(product.orders[i].state >= 18) {
              confirmed += product.orders[i].amount;
            }
          }
        }
      }

      let text = '<table style="width: 100%;">';
      text += '<tr><td style="padding:2px 10px; font-weight: bold; text-align: right;">' + quantity + '</td><td style="padding: 2px 10px;"> ordered </td></tr>';

      if(picked > 0) {
        text += '<tr><td style="padding:2px 10px; font-weight: bold; text-align: right;">' + picked + '/' + quantity + '</td><td style="padding: 2px 10px;"> picked </td><td>';
        if(picked === quantity) {
          text += '<span><i class="fas fa-check"></i></span>';
        }
        text += '</td></tr>';
      }
      if(checked > 0) {
        text += '<tr><td style="padding:2px 10px; font-weight: bold; text-align: right;">' + checked + '/' + quantity + '</td><td style="padding: 2px 10px;"> checked </td><td>';
        if(checked === quantity) {
          text += '<span><i class="fas fa-check"></i></span>';
        }
        text += '</td></tr>';
      }
      if(confirmed > 0) {
        text += '<tr><td style="padding:2px 10px; font-weight: bold; text-align: right;">' + confirmed + '/' + quantity + '</td><td style="padding: 2px 10px;"> confirmed </td><td>';
        if(confirmed === quantity) {
          text += '<span><i class="fas fa-check"></i></span>';
        }
        text += '</td></tr>';
      }


      text += "</table>";
      return text;
    },
    onDeliveryDateSelected: function(date) {
      this.$data.deliveryDate = date;
      this.$data.showDateSelector = false;
      this.getDriverList();
    },
    getDriverList: function() {
      let self = this;

      if(this.$data.deliveryDate === null || this.$data.deliveryDate === '' ) {
        showDialog("Please select date");
        return;
      }
      this.$data.selectedDriverId = 0;
      getWmsDriverList(this.$data.deliveryDate)
        .then(function(data) {
          if(data.success === true) {
            console.log("get drivers");
            console.log(data.item);
            data.item.sort(function(a, b){
              if(a.name > b.name) {
                return 1;
              } else if (a.name < b.name){
                return -1;
              }
              return 0;
            })
            self.$data.drivers = data.item;
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ' )';
          }
          showDialog(msg, "ERROR at getting category list");
        })
    },
    showProductInfoView: function(product) {
      this.$data.productInfo = {
        title: product.title,
        code: product.code,
        image:product.imageUrls !== null && product.imageUrls.length > 0?product.imageUrls[0]:null,
      }

    },
    getCategories: function() {
      let self = this;
      getWmsCategories()
        .then(function(data) {
          if(data.success === true) {
            self.$data.categories = data.item;
            console.log("categories");
            console.log(self.$data.categories);
            self.getDriverList();
            self.setWebsocketConnection();
          } else {
            showDialog("Could not get category list");
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ' )';
          }
          showDialog(msg, "ERROR at getting category list");
        })
    },
    getItemisedOrderList: function() {
      this.$data.orders = [];
      this.$data.orderCategories = [];
      if(this.$data.deliveryDate === null || this.$data.deliveryDate === "" || this.$data.deliveryDate === '0000-00-00') {
        return;
      }

      // if(this.$data.selectedDriverId === 0) {
      //   showDialog("Please select a driver to get itemised orders");
      //   return;
      // }
      let self = this;
      getWmsItemisedOrders(this.$data.deliveryDate, this.$data.selectedDriverId)
        .then(function(data) {
          if(data.success === true) {
            self.$data.orderCategories = data.item;
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR at getting order item list");
        })

    },
    getOrderList: function(refresh) {
      if(refresh === true) {
        this.$data.orders = [];
      }
      this.$data.orderCategories = [];
      if(this.$data.deliveryDate === null || this.$data.deliveryDate === "" || this.$data.deliveryDate === '0000-00-00') {
        return;
      }

      // if(this.$data.selectedDriverId === 0) {
      //   return;
      // }
      let self = this;
      getWmsOrders(this.$data.deliveryDate, this.$data.selectedDriverId, true)
        .then(function(data) {
          if(data.success === true) {
            data.item.sort(function(a, b) {
              if(a.merchantTitle < b.merchantTitle) {
                return -1;
              } else if(a.merchantTitle > b.merchantTitle) {
                return 1;
              }
              return 0;
            })
            if(refresh === true) {
              self.$data.orders = data.item;
            } else {
              for(let i = 0 ; i < data.item.length ; i++) {
                let found = false;
                for(let j = 0 ; j < self.$data.orders.length ; j++) {
                  if(data.item[i].id === self.$data.orders[j].id) {
                    self.$data.orders.splice(j, 1, data.item[i]);
                    found = true;
                    break;
                  }
                }
                if(found === false) {
                  self.$data.orders.push(data.item[i]);
                }
              }
            }
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR at getting order item list");
        })

    },
    openOrder: function(id) {
      let self = this;
      getWmsOrder(id)
        .then(function(data) {
          if(data.success === true) {
            for(let i = 0 ; i < data.item.list.length ; i++) {
              for(let c = 0 ; c < self.$data.categories.length ; c++) {
                if(data.item.list[i].categoryTitle === self.$data.categories[c].title) {
                  data.item.list[i].categoryCode = self.$data.categories[c].code;
                }
              }
              // console.log(data.item.list[i].title + " category " + data.item.list[i].categoryTitle + "  code: " +  data.item.list[i].categoryCode);
            }
            data.item.list.sort(function(a, b) {
              if(a.categoryCode < b.categoryCode) {
                return -1;
              }
              if(a.categoryCode > b.categoryCode) {
                return 1;
              }
              return 0;
            })
            self.$data.order = data.item;
            console.log("open order");
            console.log(self.$data.order);
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err){
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR at getting order");
        })

    },
    onCategoryChanged: function() {

      this.$data.items = [];
      let self = this;

      if(this.$data.selectedCategoryId === 0) {
        return;
      }
      if(this.$data.deliveryDate === null || this.$data.deliveryDate === "" || this.$data.deliveryDate === '0000-00-00') {
        return;
      }
      getWmsDeliveryOrderItems(this.$data.selectedCategoryId, this.$data.deliveryDate)
        .then(function(data) {
          if(data.success === true) {
            self.$data.items = data.item;
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR at getting order item list");
        })
    },
    showPickView: function(item, inventory) {

      let available = inventory.availableQuantity;
      let alreadyPicked = item.midStockQuantity;

      let toOrder = item.amount - item.midStockQuantity;

      console.log("available: " + available + " already picked:" + item.midStockQuantity + " to order:" + toOrder);
      let max = available >= toOrder ? toOrder : available;
      this.$data.pickView = {
        item: item,
        inventory: inventory,
        maxQuantity: max,
        form: {
          orderItemId: item.id,
          inventoryId: inventory.id,
          quantity: 0,
        }
      }
    },

    openWeightFixView: function(item, merchant) {
      this.$data.weightStockView = {
        order:item,
        merchant: merchant,
        orderItemId: item.id,
        weightInput:'',
        weight:0,
        fixPicking: true,
        quantity: item.amount,
      }
    },
    openPickingFixView: function(item) {

      this.$data.pickingFixView = {
        item: item,
        maxQuantity: item.availablePickQuantity,
        form: {
          orderItemId: item.id,
          quantity: 0,
          state: 15,
        }
      }
    },
    closePickingFixView: function() {
      this.$data.pickingFixView = false;
    },
    submitPickingFix: function() {
      if(this.$data.pickingFixView === false) {
        return;
      }

      if(this.$data.pickingFixView.form.quantity === this.$data.pickingFixView.item.midStockQuantity) {
        showDialog("Quantity is the same");
        return;
      }


      let self = this;
      wmsOrderItemPickingCorrection(this.$data.pickingFixView.form)
        .then(function(data) {
          if(data.success === true) {
            if(self.$data.order !== false) {
              for (let i = 0; i < self.$data.order.list.length; i++) {
                if (self.$data.order.list[i].id === data.order.id) {
                  self.$data.order.list.splice(i, 1, data.order);
                  break;
                }
              }
            }
            self.closePickingFixView();
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR at setting full picking quantity");
        })
    },
    closePickView: function() {
      this.$data.pickView = false;
    },

    submitOrderItemsPick: function(product) {
      let forms = [];
      for(let i = 0 ; i < product.orders.length ; i++) {
        forms.push({
          orderItemId: product.orders[i].id,
          quantity: product.orders[i].amount,
        })
      }

      let form = {
        forms: forms
      };

      let self = this;
      wmsProductOrderItemsMidStockCreate(form)
        .then(function(data) {
          if(data.success === true) {
            if(data.product !== null) {
              for(let i = 0 ; i < self.$data.orderCategories.length ; i++) {
                for(let j = 0 ; j < self.$data.orderCategories[i].products.length ; j++) {
                  if(self.$data.orderCategories[i].products[j].id === data.product.id) {
                    self.$data.orderCategories[i].products.splice(j, 1, data.product);
                    return;
                  }
                }
              }
            }
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR at setting full picking quantity");
        })
    },
    submitOrderItemPick: function(item) {
      let form = {
        orderItemId: item.id,
        quantity: item.availablePickQuantity,
      }

      let self = this;
      wmsOrderItemMidStockCreate(form)
        .then(function(data) {
          if(data.success === true) {
            if(data.order !== undefined && self.$data.order !== false) {
              for(let i = 0 ; i < self.$data.order.list.length ; i++) {
                if(self.$data.order.list[i].id === data.order.id) {
                  self.$data.order.list.splice(i, 1, data.order);
                  self.$data.pickView = false;
                  return;
                }
              }
              showDialog("Something went wrong. Please refresh order view");
            }
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR at setting full picking quantity");
        })
    },
    submitPick: function() {
      if(this.$data.pickView === false) {
        return;
      }

      if(this.$data.pickView.form.quantity === 0) {
        showDialog("Please select quantity");
        return;
      }

      let self = this;
      wmsMidStockCreate(this.$data.pickView.form)
        .then(function(data) {
          if(data.success) {
            if(data.order !== undefined && self.$data.order !== false) {
              for(let i = 0 ; i < self.$data.order.list.length ; i++) {
                if(self.$data.order.list[i].id === data.order.id) {
                  self.$data.order.list.splice(i, 1, data.order);
                  self.$data.pickView = false;
                  return;
                }
              }
              showDialog("Something went wrong. Please refresh order view");
            }
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR at setting full picking quantity");
        })

    },
    showPartialConfirmView: function(item) {
      this.$data.partialConfirmView = {
        item: item,
        orderId: item.parentId,
        itemId:  item.id,
        orderedAmount: item.amount,

        amountToConfirm: 0,
      }
    },
    closePartialConfirmView: function() {
      this.$data.partialConfirmView = false;
    },
    itemPartialConfirm: function() {

      let self = this;
      if(this.$data.partialConfirmView.amountToConfirm === 0) {
        showDialog("Please select quantity to confirm");
        return;
      }

      getWmsPickerConfirm(this.$data.partialConfirmView.orderId, this.$data.partialConfirmView.itemId, this.$data.partialConfirmView.orderedAmount, this.$data.partialConfirmView.amountToConfirm)
        .then(function(data) {
          if(data.success === true) {
            self.$data.partialConfirmView = false;
            if(self.$data.order !== false) {
              for (let i = 0; i < self.$data.order.list.length; i++) {
                if (self.$data.order.list[i].id === data.item.id) {
                  self.$data.order.list.splice(i, 1, data.item);
                  return;
                }
              }
            }
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR at setting full picking quantity");
        })
    },
    openWeightInputView: function(item, merchant) {
      this.$data.weightStockView = {
        order:item,
        merchant: merchant,
        orderItemId: item.id,
        weightInput:'',
        weight:0,
        fixPicking: false,
        quantity: item.amount,
      }
    },
    closeWeightInputView: function() {
      this.$data.weightStockView = false;
    },
    submitWeightInput: function() {

      if(this.$data.weightStockView.fixPicking === true) {
        if(this.$data.weightStockView.weight >= 10000) {
          this.$data.weightStockView.weight = 0;
          this.$data.weightStockView.weightInput = '';
          this.updateWeightNumber();
          showDialog("Weight should be less than 100kg");
          return;
        }
        let self = this;

        wmsOrderItemPickingCorrection(this.$data.weightStockView)
          .then(function(data) {
            if(data.success === true) {
              if(self.$data.order !== false) {
                for (let i = 0; i < self.$data.order.list.length; i++) {
                  if (self.$data.order.list[i].id === data.order.id) {
                    self.$data.order.list.splice(i, 1, data.order);
                    break;
                  }
                }
              }
              self.closeWeightInputView();
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            let msg = err;
            if(err.response !== undefined) {
              msg += ' (' + err.response + ')';
            }
            showDialog(msg, "ERROR at setting full picking quantity");
          })

      } else {
        if (this.$data.weightStockView.weight === 0) {
          showDialog("Please enter the weight");
          return;
        }

        if (this.$data.weightStockView.weight >= 10000) {
          this.$data.weightStockView.weight = 0;
          this.$data.weightStockView.weightInput = '';
          this.updateWeightNumber();
          showDialog("Weight should be less than 100kg");
          return;
        }
        let self = this;
        wmsOrderItemMidStockCreate(this.$data.weightStockView)
          .then(function (data) {
            if (data.success === true) {
              if (data.order !== undefined && self.$data.order !== false) {
                for (let i = 0; i < self.$data.order.list.length; i++) {
                  if (self.$data.order.list[i].id === data.order.id) {
                    self.$data.order.list.splice(i, 1, data.order);
                    self.$data.pickView = false;
                    self.closeWeightInputView();
                    return;
                  }
                }

              } else if (self.$data.orderCategories.length > 0) {
                for (let i = 0; i < self.$data.orderCategories.length; i++) {
                  for (let j = 0; j < self.$data.orderCategories[i].products.length; j++) {
                    if (self.$data.orderCategories[i].products[j].id === data.order.productId) {
                      for (let o = 0; o < self.$data.orderCategories[i].products[j].orders.length; o++) {
                        if (self.$data.orderCategories[i].products[j].orders[o].id === data.order.id) {
                          data.order.merchant = self.$data.orderCategories[i].products[j].orders[o].merchant;
                          self.$data.orderCategories[i].products[j].orders.splice(o, 1, data.order);
                          self.closeWeightInputView();
                          return;
                        }
                      }
                    }
                  }
                }

              }
              showDialog("Something went wrong. Please refresh order view");
            } else {
              showDialog(data.message);
            }
          })
          .catch(function (err) {
            let msg = err;
            if (err.response !== undefined) {
              msg += ' (' + err.response + ')';
            }
            showDialog(msg, "ERROR at setting picking weight");
          })
      }
    },
    weightNumberEntered: function(number) {
      let input = this.$data.weightStockView.weight.toString() + number.toString();

      this.$data.weightStockView.weight = parseInt(input);
      this.updateWeightNumber();
      // this.$data.weightStockView.weightInput += number.toString();
    },
    clearWeightInput: function() {
      this.$data.weightStockView.weight = 0;
      this.updateWeightNumber();
    },
    updateWeightNumber: function() {

      let number = this.$data.weightStockView.weight.toString();
      if(number.length <= 3) {
        while(number.length < 3) number = "0" + number;
      }
      this.$data.weightStockView.weightInput = number.substring(0, number.length - 2) + '.' + number.substring(number.length - 2);


    },
    weightNumberBack: function() {
      if(this.$data.weightStockView.weight < 10) {
        this.$data.weightStockView.weight = 0;
      } else {
        let input = this.$data.weightStockView.weight.toString();
        input = input.substring(0, input.length - 1);
        this.$data.weightStockView.weight = parseInt(input);
      }

      this.updateWeightNumber();
    },
    itemPickChecked: function(item) {
      let form = {
        orderItemId: item.id,
        quantity: item.midStockQuantity,
      }


      let self = this;
      wmsOrderItemMidStockChecked(form)
        .then(function(data) {
          if(data.success === true) {
            console.log(data);
            if(self.$data.order !== false && self.$data.order.list.length > 0) {
              for (let i = 0; i < self.$data.order.list.length; i++) {
                if (self.$data.order.list[i].id === data.order.id) {
                  self.$data.order.list.splice(i, 1, data.order);
                  return;
                }
              }
            } else if(self.$data.orderCategories.length > 0) {
              item.state = data.order.state;
              item.updatedTimestamp = data.order.updatedTimestamp;
            }
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          console.log(err);
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR at cancelling pick quantity");
        })

    },
    itemPickUncheck: function(item) {
      let form = {
        orderItemId: item.id,
      }


      let self = this;
      wmsOrderItemMidStockUnchecked(form)
        .then(function(data) {
          if(data.success === true) {
            console.log(data);
            if(self.$data.order !== false && self.$data.order.list.length > 0) {
              for(let i = 0 ; i < self.$data.order.list.length ; i++) {
                if(self.$data.order.list[i].id === data.order.id) {
                  self.$data.order.list.splice(i, 1, data.order);
                  return;
                }
              }
            } else if(self.$data.orderCategories.length > 0) {
              item.state = data.order.state;
              item.updatedTimestamp = data.order.updatedTimestamp;
            }
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          console.log(err);
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR at cancelling pick quantity");
        })

    },
    itemConfirmCancel: function(item) {
      let self = this;
      getWmsPickerCancel(item.id)
        .then(function(data) {
          if(data.success === true) {
            console.log(data);
            if(self.$data.order !== false) {
              for (let i = 0; i < self.$data.order.list.length; i++) {
                if (self.$data.order.list[i].id === data.order.id) {
                  self.$data.order.list.splice(i, 1, data.order);
                  return;
                }
              }
            }
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          console.log(err);
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR at cancelling pick quantity");
        })
    },
    itemFullConfirm: function(item) {
      let self = this;
      getWmsPickerConfirm(item.parentId, item.id, item.amount, item.amount)
        .then(function(data) {
          if(data.success === true) {
            if(self.$data.order !== false) {
              for (let i = 0; i < self.$data.order.list.length; i++) {
                if (self.$data.order.list[i].id === data.item.id) {
                  self.$data.order.list.splice(i, 1, data.item);
                  return;
                }
              }
            }
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR at setting full picking quantity");
        })
    },
    closeOrder: function() {
      this.$data.order = false;
      this.getOrderList(false);
    },
    confirmOrder: function() {
      if(this.$data.order.state >= 15) {
        showDialog("already confirmed");
        return;
      }

      if(this.$data.order.state < 0) {
        showDialog("Already cancelled");
        return;
      }

      for(let i = 0 ; i < this.$data.order.list.length ; i++) {
        if(this.$data.order.list[i].state === 0 && this.$data.order.list[i].amount > 0) {
          showDialog(this.$data.order.list[i].title + " requires picking, If this needs to be cancelled, please talk to office staff");
          return;
        }
        if(this.$data.order.list[i].amount > 0 && this.$data.order.list[i].state >= 0 && this.$data.order.list[i].state < 15) {
          showDialog(this.$data.order.list[i].title + " has been picked but the quantity is not checked yet. Please ask a checker to check the quantity first");
          return;
        }
      }
      let self = this;
      getWmsConfirmOrder(this.$data.order.id)
        .then(function(data) {
          if(data.success === true) {
            for(let i = 0 ; i < self.$data.orders.length ; i++) {
              if(self.$data.orders[i].id === data.order.id) {
                self.$data.orders.splice(i, 1, data.order);
                break;
              }
            }
            self.closeOrder();

          } else {
            showDialog(data.message);
          }
        })

    },
    handleMessageReceipt: function (messageOutput) {
      console.log("message received " + messageOutput);
    },
    handleNotificationReceived: function(message) {
      console.log("message received " + message);
      let msg = JSON.parse(message);
      if(msg.cmd === 'newOrder') {
        if(msg.message !== undefined && msg.message.length > 0) {
          showDialog(msg.message);
        }
      } else if(msg.cmd === 'stateChanged') {
        if(msg.message !== undefined && msg.message.length > 0) {

          if(msg.orderId !== undefined && msg.orderId > 0) {
            if(this.$data.order !== null && this.$data.order !== false && this.$data.order.id === msg.orderId) {

              // showDialog(msg.message);
              // this.openOrderItem(msg.orderId);
            }

          }
        }
      }
    },
    setWebsocketConnection: function() {
      let socket = new SockJS(process.env.ROOT_BASE + 'connect');
      // let socket = new SockJS('https://api.showmemenu.net/connect');
      console.log(socket);
      this.$data.stompClient = Stomp.over(socket);
      console.log("Connect socket 2");
      let self = this;
      console.log(this.$data.stompClient);
      if(this.$data.stompClient.state === 'CONNECTED') {
        console.log("Already connected");
        self.$data.stompClient.subscribe('/topic/messages/order',
          function(messageOutput) {
            self.handleNotificationReceived(messageOutput);
          });
      } else {
        console.log("Not connected so try to connect");
        this.$data.stompClient.connect({}, function (frame) {

          self.handleMessageReceipt("Connected");
          self.$data.stompClient.subscribe('/topic/messages/order',
            function (messageOutput) {
              self.handleNotificationReceived(messageOutput.body);
            });
        }, function (frame) {
          console.log("Connect error ");
          console.log(frame);
          setTimeout(self.setWebsocketConnection, 1000);
        });
      }
    },
    disconnect: function(){
      if(this.$data.stompClient != null) {
        this.$data.stompClient.disconnect();
      }
      this.handleMessageReceipt("Disconnected");
    },
  }
}
</script>

<style scoped>
.wms-order-item {
  width: 100%;
  padding-top: 3px;
  padding-bottom: 0;
  border-bottom: 1px solid #ccc;
  background: white;
  margin-top: 15px;
  margin-bottom: 15px;
  border: 1px solid #ddd;
  background: #eee;
  border-radius: 10px;
}
.wms-order-item-container {
  width: 100%;
  display: flex;
}
.wms-order-item-title-container {
  width: 100%;
  display: flex;
}
.wms-order-item-title {
  width: 100%;
  padding: 10px;
  text-align: right;
}
.wms-order-number {
  width: 100px;
  padding: 10px;
}
.wms-order-item-quantity-container {
  width: 70px;
  padding-top: 10px;

  text-align: center;
}
.wms-order-item-quantity {
  font-size: 20px;
  font-weight: bold;
}
.wms-order-btn-container {
  width: 100%;
  display: flex;
}
.wms-order-btn-container > div {
  width: 33.33%;
  text-align: center;
}
.wms-btn {
  padding: 5px;
  border: 1px solid #ccc;
  width: calc(100% - 10px);
  margin: auto;
  border-radius: 10px;
}
.wms-white-button {
  padding: 10px 20px;
  border: 1px solid #ccc;
  border-radius: 10px;
  background: white;
}
.partial-confirmed {
  background: #f4d03f;
}
.full-confirmed {
  background: #99daff;
}
.order-confirmed {
  background: #ccc;
}
.quantity-btn {
  padding: 10px 0;
  border: 1px solid #ccc;
  text-align: center;
  font-size: 40px;
}
.quantity-btn.selected {
  background: blue;
  color: white;
  font-weight: bold;
}
.wms-inventory-item {
  width: 100%;
  display: flex;
  padding:10px;
  margin-top: 5px;
  margin-bottom: 5px;
  border: 1px solid #ccc;
}
.wms-inventory-item > div {
  width: 30%;
}
.wms-inventory-item .wms-stock-balance {
  width: 20%;
}
.wms-stock-balance {
  font-size: 15px;
  font-weight: bold;
}
.wms-stock-picked {
  font-size: 20px;
  font-weight: bold;
  color: green;
}

.wms-order-state-0 {
  background: white;
  box-shadow: 3px 3px 10px rgba(0,0,0,0.6);
}
.wms-order-state-15 {
  background: #aeeeff;
  box-shadow: 3px 3px 10px rgba(0,0,0,0.6);
}
.wms-order-state-20 {
  background: #aeffb2;
  box-shadow: inset 3px 3px 10px rgba(0,0,0,0.6);
}
.wms-order-state-100 {
  background: #aeffb2;
  box-shadow: inset 3px 3px 10px rgba(0,0,0,0.6);
}
.wms-order-state--10 {

  background: #bbb;
  box-shadow: inset 3px 3px 10px rgba(0,0,0,0.6);
}
.wms-order-state--20 {
  background: #bbb;
  box-shadow: inset 3px 3px 10px rgba(0,0,0,0.6);
}
.wms-order-state--30 {
  background: #bbb;
  box-shadow: inset 3px 3px 10px rgba(0,0,0,0.6);
}
.wms-order-state--40 {
  background: #bbb;
  box-shadow: inset 3px 3px 10px rgba(0,0,0,0.6);
}
.wms-order-state {
  padding: 10px;
  margin-top: 3px;
  text-align: right;
  font-size: 20px;
  font-weight: bold;
  background: rgba(1,1,1,0.1);
}
.category-title {
  border-top: 10px solid red;
  font-size: 35px;
  padding-left: 20px;
  background: #ffa0a0;
  margin-bottom: 20px;
}

.wms-order-category-container {
  margin-bottom: 40px;

  padding-bottom: 10px;
}
.product-container {

  margin-top: 30px;
  background: white;
}
.product-title-container {
  width: 100%; display: flex;
  background: #f7f7f7;
  border-bottom: 1px solid #aaa;
}
.product-title {
  padding: 10px;
  font-size: 20px;
  font-weight: bold;

}

.number-input{
  background: #d8ffc7;
  line-height: 70px;
  font-size: 60px;
  padding-right: 30px;
  text-align: right;
}
.number-button-container {
  margin: auto;

}
.number-button {
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  border-radius: 40px;
  background: #ccc;
  margin: 10px;
  font-size: 50px;
  box-shadow: 3px 3px 5px gray;
}
.number-button:focus, .number-button:active{
  box-shadow: 1px 1px 2px gray;;
}
.number-button.darker {
  background: #aaa;
}

.top-container {
  width: 100%;
  height: 110px;
}
.body-container {
  width:100%; height: calc(100% - 110px); overflow-y: auto; border-top: 1px solid #ccc; background: #bbb;
}
.product-order-item-container {
  display: block;
}
@media all and (min-width: 430px) {
  .product-order-item-container {
    width: 100%;
    display: inline-block;
  }
  .product-order-item-container > div {
    width: calc(50% - 20px);
    float: left;
    margin: 10px;
  }
}
@media all and (min-width: 600px) {
  .top-container {
    height: 60px;
  }
  .body-container {
    height: calc(100% - 60px);
  }
  .product-order-item-container {
    width: 100%;
    display: inline-block;
  }

}
.wms-driver-info {
  padding-left: 10px;
}
.product-title-new {
  text-align: center;
  font-size: 20px;
  padding: 5px;
  font-weight: bold;
  border-bottom: 1px solid #b2b2b2;


}
.product-image-title {
  display: flex;
}
.product-image-code {
  width: calc(100% - 180px);
  font-weight: bold;
  font-size: 30px;
  line-height: 100px;
}
.product-image-container-quantity {
  width: 80px;
  height: 100px;
  line-height: 100px;
  font-size: 30px;
  font-weight: bold;
  text-align: center;

}
.product-title-bg-0 {
  background: #A7C7E7;
  color: black;
}
.product-title-bg-1 {
  background: #B2D8B2;
  color: black;
}
.product-title-bg-2 {
  background: #F2E2A7;
  color: black;
}
.product-title-bg-3 {
  background: #D3B2E7;
  color: black;
}
.product-title-bg-4 {
  background: #E0E0E0;
  color: black;
}
.product-title-bg-5 {
  background: #D89090;
  color: black;
}
.margin-top-40 {
  margin-top: 40px;
}
.v-expansion-panel-content>>> .v-expansion-panel-content__wrap {
  padding: 0 !important;
}

.summary-container-td{
  padding: 10px;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderStocks.vue